import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { TextInputFieldWUT } from '../../../ui/text-input-field';
export const EcomAdditionalInfoWUT = props => {
  const fieldType = FIELD_TYPES.ECOM_ADDITIONAL_INFO;
  return /*#__PURE__*/React.createElement(TextInputFieldWUT, _extends({}, props, {
    fieldType: fieldType
  }));
};
//# sourceMappingURL=ecom-additional-info-wut.js.map